import React from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import UnclaimedAwardsTable from './components/UnclaimedAwardsTable';

const UnclaimedAwards = () => {
  const { t } = useTranslation();

  return (
    <div className="manage-reward">
    <Container>
      <Row>
        <Col md={12}>
          <h3>{t('unclaimed_awards')}</h3>
          <h3 className="page-subhead subhead">
            {t('unclaimed_awards_manager_desc')}
          </h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <UnclaimedAwardsTable />
        </Col>
      </Row>
    </Container>
    </div>
  );
};

export default UnclaimedAwards;